import { RootInitialState } from 'core/common/store/rootReducer';

export const getHumanDesignReport = (state: RootInitialState) => {
  return state.humanDesign.report;
};
